/* Leaflet map */
/* eslint-disable */
document.addEventListener('DOMContentLoaded', function () {
    const mapMarker = document.getElementById('map-marker');

    // Get marker data from data attributes
    const mapLong = mapMarker.getAttribute('data-map-longitude');
    const mapLat = mapMarker.getAttribute('data-map-latitude');
    const mapDesc = mapMarker.getAttribute('data-map-description');
    const mapName = mapMarker.getAttribute('data-map-marker-name');
    const mapLink = `<a href="${mapMarker.getAttribute('data-map-directions')}" target="_blank">Get Directions</a>`;

    // GeoJSON data 
    const geojsonFeature = [
        {
            "type": "Feature",
            "properties": {
                "name": mapName,
                "description": mapDesc,
                "popupContent": `<strong>${mapName}</strong>${mapDesc}${mapLink}`,
            },
            "geometry": {
                "type": "Point",
                "coordinates": [mapLong, mapLat]
            }
        },
    ];

    // Initialize Map
    const map = L.map('map', {
        center: [mapLat, mapLong],
        zoom: 16,
    });

    // Add map layer
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        minZoom: 8,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    var popup = L.popup();

    // Add the GeoJSON data to the map
    function onEachFeature(feature, layer) {
        if (feature.properties && feature.properties.popupContent) {
            layer.bindPopup(feature.properties.popupContent);
            // Open the popup by default
            layer.on('add', function () {
                layer.openPopup();
            });
        }
    }

    L.geoJSON(geojsonFeature, {
        onEachFeature: onEachFeature
    }).addTo(map);
});
